import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";
import checkIconRed from '../../../resources/images/alert-circle.svg';

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "22px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px"
  },
  checkbox: {
    marginRight: "8px",
    cursor: "pointer",
    "&:checked": {
      outline: theme.buttons.primary.border + "!important",
    },
    "&:hover": {
      border: theme.modal.optionHover.border,
      backgroundColor: theme.modal.optionHover.backgroundColor,
      "&:checked": {
        backgroundColor: theme.modal.backgroundColor,
        borderColor: theme.modal.optionHover.backgroundColor
      }
    },
  },
  modal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      wordBreak: "break-word"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      wordBreak: "break-word"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  removeInput: {
    padding: "8px 12px 8px 12px",
  },
  deleteActionNote: {
    marginBottom: "6px",
    marginTop: "16px"
  },
  confirmDeleteModalAdditionalText: {
    marginTop: "8px"
  },
  noteText: {
    fontWeight: "600"
  },
  removalWillBeScheduled: {
    marginBottom: "8px"
  },
  numberOfDays: {
    fontWeight: "600"
  },
  removeDueToFraudText: {
    marginTop: "20px",
    marginBottom: "12px",
    fontWeight: "600"
  },
  fraudCategoryInput: {
    color: colors.inactiveGrey,
    padding: "8px 12px 8px 12px",
    "& input":{
      border: "1px solid " + colors.red,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin:"content-box",
      backgroundImage: `url(${checkIconRed})`
    },
  },
  cancelBtn: {
    extend: "footerBtns",
  },
  cancelBtnCol: {
    paddingRight: "6px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      paddingLeft: "10px",
      paddingRight: "2px"
    }
  },
  saveBtn: {
    extend: "footerBtns",
    backgroundColor: colors.brightRed,
  },
  customDisabled: {
    pointerEvents: "none",
    backgroundColor: `${colors.disabledRed} !important`,
    border: `1px solid ${colors.disabledRed}`,
    "&:hover":{
      border: `1px solid ${colors.disabledRed}`,
    }
  },
  saveBtnCol: {
    paddingLeft: "6px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      paddingLeft: "4px",
      paddingRight: "10px"
    }
  },
  inputContainer:{
    "& input":{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      paddingRight: "35px",
      border: "1px solid " + colors.mediumRed,
      backgroundSize: "16px 16px",
      backgroundPosition: "right -25px center",
      backgroundRepeat: "no-repeat",
      backgroundOrigin:"content-box",
      backgroundImage: `url(${checkIconRed})`,
      padding: "0px 0px 0px 12px"
    },
  },
  nameError: {
    fontSize: "14px",
    fontWeight:"400",
    color: colors.red,
    marginTop: "6px"
  },
}));

export default styles;